import { Line, mixins } from "vue-chartjs"
// KEEP ChartAnnotation import otherwise plugin not auto-loaded
// eslint-disable-next-line
import * as ChartAnnotation from "chartjs-plugin-annotation"

// https://dev.to/apertureless/lets-build-a-web-app-with-vue-chartjs-and-an-api
export default Line.extend({
    mixins: [mixins.reactiveProp],
    props: ["chartData", "options"],
    watch: {
        options: {
            handler (newOption, oldOption) {
                if(this._chart) this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
